// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gaWpl","itemGrid":"styles_itemGrid__sBeWy"};